export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Download our lightweight application for your device and install it in seconds. Available for all major platforms.'
    },
    {
      number: '02',
      title: 'Create Account',
      description: 'Sign up with your email and choose your preferred plan. No credit card required for the free trial.'
    },
    {
      number: '03',
      title: 'Connect Securely',
      description: 'Click connect and enjoy instant protection. Your internet traffic is now encrypted and your privacy is secured.'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="how-it-works" className="relative py-32 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/c1a02422a735e241b5a49f5977296bad.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-cyan-50/80 via-purple-50/80 to-cyan-50/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-12">
        <h2 className="text-5xl font-bold text-gray-900 text-center mb-20">
          Get Started in 3 Simple Steps
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-3xl p-12 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="text-8xl font-bold bg-gradient-to-br from-cyan-500 to-purple-600 bg-clip-text text-transparent mb-6">
                  {step.number}
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-lg text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-3xl text-cyan-500"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={scrollToContact}
            className="bg-black text-white px-12 py-5 rounded-full text-lg font-semibold hover:bg-gray-900 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Download Now
          </button>
        </div>
      </div>
    </section>
  );
}
